import * as flightNetwork from "./flightNetworks";
import * as googleMaps from "./googleMaps";

const oversight = {
  ...flightNetwork,
  ...googleMaps
}

export default oversight